import { Flex, SimpleGrid } from "@chakra-ui/react";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useEffect, useState } from "react";
import { Header } from "components/Header";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import utils from "utils";
import InputComp from "components/InputComp";
import ButtonComp from "components/Button";
import Layout from "components/Layout";

// const items = [
//   {
//     id: 1,
//     Attached: "Attached",
//     "Group Name": "Group Name",
//   },
// ];

function Guarantee() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [purchasedurDD, setPurchasedurDD] = useState([]);
  const [purClaimLimitDD, setPurClaimLimitDD] = useState([]);

  const action = location?.state?.action;
  const itemData = location?.state?.data;
  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();

  // const [address1, setAddress1] = useState(itemData?.address1 || "");
  // const [address2, setAddress2] = useState(itemData?.address2 || "");
  // const [address3, setAddress3] = useState(itemData?.address3 || "");
  // const [company, setCompany] = useState(itemData?.company || "");
  // const [country, setCountry] = useState(itemData?.country || "");
  // const [email, setEmail] = useState(itemData?.email || "");
  // const [forename, setForename] = useState(itemData?.forename || "");
  // const [hometel, setHometel] = useState(itemData?.hometel || "");
  // const [mobile, setMobile] = useState(itemData?.mobile || "");
  // const [policyid, setPolicyid] = useState(itemData?.policyid || "");
  // const [policynumber, setPolicynumber] = useState(
  //   itemData?.policynumber || ""
  // );
  // const [postcode, setPostcode] = useState(itemData?.postcode || "");
  // const [surname, setSurname] = useState(itemData?.surname || "");
  // const [title, setTitle] = useState(itemData?.title || "");
  // const [town, setTown] = useState(itemData?.town || "");
  // const [recordtype, setRecordtype] = useState(itemData?.recordtype || "");
  // const [branchid, setBranchid] = useState(itemData?.branchid || "");
  // const [branchname, setBranchname] = useState(itemData?.branchname || "");
  // const [dateseconds, setDateseconds] = useState(itemData?.dateseconds || "");
  // const [coverid, setCoverid] = useState(itemData?.coverid || "");
  // const [operator, setOperator] = useState(itemData?.operator || "");
  // const [state, setState] = useState(itemData?.state || "");
  // const [datepolicy, setDatepolicy] = useState(itemData?.datepolicy || "");
  // const [invoiceid, setInvoiceid] = useState(itemData?.invoiceid || "");
  // const [nett, setNett] = useState(itemData?.nett || "");
  // const [tax, setTax] = useState(itemData?.tax || "");
  // const [gross, setGross] = useState(itemData?.gross || "");
  // const [invoicenumber, setInvoicenumber] = useState(
  //   itemData?.invoicenumber || ""
  // );
  // const [vatpercent, setVatpercent] = useState(itemData?.vatpercent || "");
  // const [county, setCounty] = useState(itemData?.county || "");
  // const [poladmincosttype, setPoladmincosttype] = useState(
  //   itemData?.poladmincosttype || ""
  // );
  // const [poladmincostcent, setPoladmincostcent] = useState(
  //   itemData?.poladmincostcent || ""
  // );
  // const [poladmincostamt, setPoladmincostamt] = useState(
  //   itemData?.poladmincostamt || ""
  // );
  // const [pricepaid, setPricepaid] = useState(itemData?.pricepaid || "");
  // const [deposit, setDeposit] = useState(itemData?.deposit || "");
  // const [notifyemail, setNotifyemail] = useState(itemData?.notifyemail || "");
  // const [policycommissionaccount, setPolicycommissionaccount] = useState(
  //   itemData?.policycommissionaccount || ""
  // );
  // const [policycommissiontype, setPolicycommissiontype] = useState(
  //   itemData?.policycommissiontype || ""
  // );
  // const [policycommissionamt, setPolicycommissionamt] = useState(
  //   itemData?.policycommissionamt || ""
  // );
  // const [policycommissioncent, setPolicycommissioncent] = useState(
  //   itemData?.policycommissioncent || ""
  // );
  // const [policycommissionvalue, setPolicycommissionvalue] = useState(
  //   itemData?.policycommissionvalue || ""
  // );
  // const [policycommissionpaytype, setPolicycommissionpaytype] = useState(
  //   itemData?.policycommissionpaytype || ""
  // );
  // const [vatcalculation, setVatcalculation] = useState(
  //   itemData?.vatcalculation || ""
  // );
  // const [policyrefundtype, setPolicyrefundtype] = useState(
  //   itemData?.policyrefundtype || ""
  // );
  // const [policyrefundvalue, setPolicyrefundvalue] = useState(
  //   itemData?.policyrefundvalue || ""
  // );
  // const [policyrefundduration, setPolicyrefundduration] = useState(
  //   itemData?.policyrefundduration || ""
  // );
  // const [refunddone, setRefunddone] = useState(itemData?.refunddone || "");
  // const [taxadmin, setTaxadmin] = useState(itemData?.taxadmin || "");
  // const [dateexpiry, setDateexpiry] = useState(itemData?.dateexpiry || "");
  // const [renewnotified, setRenewnotified] = useState(
  //   itemData?.renewnotified || ""
  // );
  // const [accepted, setAccepted] = useState(itemData?.accepted || "");
  // const [customersent, setCustomersent] = useState(
  //   itemData?.customersent || ""
  // );
  // const [customerstripeid, setCustomerstripeid] = useState(
  //   itemData?.customerstripeid || ""
  // );
  // const [carmake, setCarmake] = useState(itemData?.carmake || "");
  // const [carmodel, setCarmodel] = useState(itemData?.carmodel || "");
  // const [cartype, setCartype] = useState(itemData?.cartype || "");
  // const [enginecapacity, setEnginecapacity] = useState(
  //   itemData?.enginecapacity || ""
  // );
  // const [fourbyfour, setFourbyfour] = useState(itemData?.fourbyfour || "");
  // const [fueltype, setFueltype] = useState(itemData?.fueltype || "");
  // const [luxury, setLuxury] = useState(itemData?.luxury || "");
  // const [mileage, setMileage] = useState(itemData?.mileage || "");
  // const [purchaseprice, setPurchaseprice] = useState(
  // itemData?.purchaseprice || ""
  // );
  // const [specialist, setSpecialist] = useState(itemData?.specialist || "");
  // const [transmission, setTransmission] = useState(
  //   itemData?.transmission || ""
  // );
  // const [vin, setVin] = useState(itemData?.vin || "");
  // const [vrm, setVrm] = useState(itemData?.vrm || "");
  // const [vehicleid, setVehicleid] = useState(itemData?.vehicleid || "");
  // const [extranum, setExtranum] = useState(itemData?.extranum || "");
  // const [datepurchase, setDatepurchase] = useState(
  // itemData?.datepurchase || ""
  // );
  // const [datereg, setDatereg] = useState(itemData?.datereg || "");
  // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  // const [carcolour, setCarcolour] = useState(itemData?.carcolour || "");
  // const [policyidvehicle, setPolicyidvehicle] = useState(
  // itemData?.policyidvehicle || ""
  // );
  // const [guaranteeid, setGuaranteeid] = useState(itemData?.guaranteeid || "");
  const [startdate, setStartdate] = useState(
    utils.dateToDateInput(itemData?.startdate)
  );
  // const [covertype, setCovertype] = useState(itemData?.covertype || "");
  const [vehiclecategory, setVehiclecategory] = useState(
    itemData?.vehiclecategory || ""
  );
  // const [durationid, setDurationid] = useState(itemData?.durationid || "");
  // const [mileageband, setMileageband] = useState(itemData?.mileageband || "");
  const [dpfs, setDpfs] = useState(itemData?.dpfs || "");
  const [higherlabourrate, setHigherlabourrate] = useState(
    itemData?.higherlabourrate || ""
  );
  const [weartear, setWeartear] = useState(itemData?.weartear || "");
  const [egrvalves, setEgrvalves] = useState(itemData?.egrvalves || "");
  const [catalyticconverter, setCatalyticconverter] = useState(
    itemData?.catalyticconverter || ""
  );
  // const [retailprice, setRetailprice] = useState(itemData?.retailprice || "");
  // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  const [claimlimitamount, setClaimlimitamount] = useState(
    // itemData?.claimlimitamount ||
    ""
  );
  const [claimlimitid, setClaimlimitid] = useState(
    // itemData?.claimlimitid ||
    0
  );
  // const [coverid, setCoverid] = useState(itemData?.coverid || '');
  // const [startdateseconds, setStartdateseconds] = useState(
  //   itemData?.startdateseconds || utils.dateToEpoch(new Date())
  // );
  // const [policyidguarantee, setPolicyidguarantee] = useState(
  //   itemData?.policyidguarantee || ""
  // );
  const [durationid, setDurationid] = useState(itemData?.durationid || "");
  // const [durationtype, setDurationtype] = useState(
  //   itemData?.durationtype || ""
  // );
  // const [active, setActive] = useState(itemData?.active || "");
  // const [hide, setHide] = useState(itemData?.hide || "");
  // const [durationvalue, setDurationvalue] = useState(
  //   itemData?.durationvalue || ""
  // );

  const genData = () => ({
    ...itemData,
    catalyticconverter,
    startdate: utils.dateToDateInput(startdate),
    startdateseconds: startdate ? utils.yyyymmddToDbSec(startdate) : 0,
    // datepolicy: startdate,
    vehiclecategory,
    durationid: parseInt(durationid || 0),
    // purchaselimitid: parseInt(claimlimitid || 0),
    claimlimitid: parseInt(claimlimitid || 0),
    claimlimitamount: parseInt(claimlimitamount || 0),
    dpfs,
    higherlabourrate,
    weartear,
    egrvalves,
    retailprice: 0,

    // sp
    // dateseconds: utils.dateStrToEpoch(itemData?.dateseconds),
    datepolicy: utils.dateToDateInput(itemData?.datepolicy),
    datereg: itemData?.datereg ? utils.dateToDateInput(itemData?.datereg) : "",
    regdate: itemData?.datereg
      ? utils.yyyymmddToDbSec(utils.dateToDateInput(itemData?.datereg))
      : "",

    datepurchase: itemData?.datepurchase
      ? utils.dateToDateInput(itemData?.datepurchase)
      : "",
    purchasedate: itemData.datepurchase
      ? utils.yyyymmddToDbSec(utils.dateToDateInput(itemData?.datepurchase))
      : 0,

    policyid: itemData?.policyid,
    // title: title,
    // policyidguarantee,
    // policyidvehicle,
  });

  const onSave = async () => {
    let errMsg = false;

    if (errMsg === false && !startdate) {
      errMsg = "start date";
    }

    // if (errMsg === false && !vehiclecategory) {
    //   errMsg = "vehiclecategory";
    // }

    if (errMsg === false && !durationid) {
      errMsg = "purchase duration";
    }

    if (errMsg === false && !claimlimitid) {
      errMsg = `purchase claim limit ${claimlimitid}`;
    }

    if (errMsg === false && !claimlimitamount) {
      errMsg = "claim limit amount";
    }

    if (errMsg) {
      toaster.create({
        title: "enter valid " + errMsg,
        type: "error",
      });
      return;
    }

    console.log("itemData", itemData);
    const pdata = genData();

    if (itemData?.policyid) {
      setIsLoading(true);
      await api
        .updateAgreement(
          pdata
          //  ...itemData,
          //  catalyticconverter,
          //  startdate: startdate,
          //  datepolicy: startdate,
          //  vehiclecategory,
          //  durationid: parseInt(durationid || 0),
          //  claimlimitid: parseInt(claimlimitid || 0),
          //  claimlimitamount: parseInt(claimlimitamount || 0),
          //  dpfs,
          //  higherlabourrate,
          //  weartear,
          //  egrvalves,
          //  retailprice: 0,
          // policyidguarantee,
          // policyidvehicle,
        )
        .then((res) => {
          setIsLoading(false);

          if (res?.status === 200) {
            navigate("/agreements");
          } else {
            toaster.create({
              title: res?.message || "fail",
              type: "error",
            });
          }
        });
    } else {
      setIsLoading(true);
      await api
        .addAgreement(
          pdata
          //  ...itemData,
          //  catalyticconverter,
          //  startdate: startdate,
          //  datepolicy: startdate,
          //  vehiclecategory,
          //  durationid: parseInt(durationid || 0),
          //  claimlimitid: parseInt(claimlimitid || 0),
          //  claimlimitamount: parseInt(claimlimitamount || 0),
          //  dpfs,
          //  higherlabourrate,
          //  weartear,
          //  egrvalves,
          //  retailprice: 0,
          // policyidguarantee,
          // policyidvehicle,
        )
        .then((res) => {
          setIsLoading(false);
          if (res?.status === 200) {
            navigate("/agreements");
          } else {
            toaster.create({
              title: res?.message || "fail",
              type: "error",
            });
          }
        });
    }
  };

  const onClose = () => {
    navigate("/agreements");
  };

  const onPrev = () => {
    navigate("/vehicledetails", {
      state: {
        action: "agreement-edit-2",
        data: genData(),
      },
    });
  };

  const clearForm = () => {
    setStartdate();
    setVehiclecategory("");
    onChangePurchasedurDD({
      action: "reset",
    });
    onChangeClaimLimitDD({
      action: "reset",
    });
    setHigherlabourrate(false);
    setWeartear(false);
    setEgrvalves(false);
    setCatalyticconverter(false);
  };

  const onChangePurchasedurDD = (data) => {
    console.log("onChangePurchasedurDD", data);
    if (data.action === "reset") {
      setDurationid("");
      if (purchasedurDD && purchasedurDD[0]) {
        setPurchasedurDD(
          data?.list?.map((a) => {
            a.selected = false;
            return a;
          })
        );
      } else {
        setPurchasedurDD([]);
      }
      return;
    }

    let did = data?.item?.data?.durationid || 0;
    // did = itemData.durationid || "";
    setPurchasedurDD(data?.list ? [...data.list] : []);
    setDurationid(did);

    // if (data?.action !== "useState") {
    getClaimamounts({
      durationid: did,
      action: data?.action,
    });

    // }
    // if (!data?.item?.data?.durationid) {
    //   setPurchasedurDD([]);
    //   setDurationid("");
    //   getClaimamounts();
    //   return;
    // }
    // setDurationid(data?.item?.label);
  };

  const getPurchaseduration = async (data) => {
    setIsLoading(true);
    return api
      .getPurchaseduration({
        coverid: itemData?.coverid,
        dealerid: itemData?.dealerid,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getPurchaseduration", res);
        if (res.status === 200) {
          if (res.data && res.data[0]) {
            const arr = res.data.map((a, index) => ({
              key: `duration-${index}`,
              value: `${a.durationvalue}-${index}`,
              label: a.durationvalue + " " + a.durationtype,
              data: a,
            }));

            if (data?.action === "useState" && itemData?.durationid) {
              let indx;
              let item;
              const arr2 = arr?.map((a, index) => {
                if (a.data.durationid === itemData.durationid) {
                  a.selected = true;
                  indx = index;
                  item = a;
                } else {
                  a.selected = false;
                }
                return a;
              });
              onChangePurchasedurDD({
                index: indx,
                item: item,
                list: arr2,
                action: data?.action,
              });
            } else {
              // arr[0].selected = true;
              onChangePurchasedurDD({
                // index: 0,
                // item: arr[0],
                list: arr,
                action: data?.action,
              });
            }
          } else {
            onChangePurchasedurDD({
              action: data?.action,
            });
          }
        } else {
          onChangePurchasedurDD({
            action: data?.action,
          });
          toaster.create({
            title: res?.message || "fail",
            type: "error",
          });
        }
      });
  };

  const onChangeClaimLimitDD = (data) => {
    console.log("onChangeClaimLimitDD", data);

    if (data.action === "reset") {
      setClaimlimitid("");
      setClaimlimitamount(0);
      if (purchasedurDD && purchasedurDD[0]) {
        setPurClaimLimitDD(
          data?.list?.map((a) => {
            a.selected = false;
            return a;
          })
        );
      } else {
        setPurClaimLimitDD([]);
      }
      return;
    }

    let purid = data?.item?.data?.purchaselimitid || "";
    let arr = JSON.parse(JSON.stringify(data?.list || []));
    setPurClaimLimitDD(arr);

    // if (!data) {
    // setPurClaimLimitDD([]);
    // setClaimlimitid("");
    // setClaimlimitamount("");
    // return;
    // }
    // console.log("vk111", data);

    setClaimlimitid(purid);
    setClaimlimitamount(data?.item?.data?.purchaselimitamount || 0);
    // if (data?.action !== "useState") {
    // }
  };

  const getClaimamounts = async (data) => {
    if (!data?.durationid) {
      onChangeClaimLimitDD({
        action: data?.action,
      });
      return;
    }
    setIsLoading(true);
    return api
      .getClaimamounts({
        coverid: itemData?.coverid,
        dealerid: itemData?.dealerid,
        durationid: data?.durationid,
      })
      .then((res) => {
        console.log("getClaimamounts", res);
        setIsLoading(false);
        if (res.status === 200) {
          if (res.data && res.data[0]) {
            let arr = res.data.map((a, index) => ({
              key: `claimamounts-${index}`,
              value: `${a.purchaselimitamount}-${index}`,
              label: a.purchaselimitamount,
              selected: false,
              data: a,
            }));

            if (data?.action === "useState" && itemData?.claimlimitid) {
              let indx;
              let item;
              arr = arr?.map((a, index) => {
                if (a.data.purchaselimitid === itemData.claimlimitid) {
                  a.selected = true;
                  indx = index;
                  item = a;
                } else {
                  a.selected = false;
                }
                return a;
              });

              onChangeClaimLimitDD({
                index: indx,
                item: item,
                list: arr,
                action: data?.action,
              });
            } else {
              // arr[0].selected = true;
              onChangeClaimLimitDD({
                // index: 0,
                // item: arr[0],
                list: arr,
                action: data?.action,
              });
            }
          } else {
            onChangeClaimLimitDD({
              action: data?.action,
            });
          }
        } else {
          onChangeClaimLimitDD({
            action: data?.action,
          });
          toaster.create({
            title: res?.message || "fail",
            type: "error",
          });
        }
      });
  };

  useEffect(() => {
    console.log("useEffect", { itemData, action });

    const cb = async () => {
      // // if (action !== "agreement-edit-3") {
      // setStartdateseconds(
      //   itemData.startdateseconds || utils.dateToEpoch(new Date())
      // );
      // }

      await getPurchaseduration({
        action: "useState",
      });
    };

    cb();

    // if (itemData?.durationid) {
    // if (itemData?.purchaselimitid) {
    //   getClaimamounts({
    //     action: "useState",
    //     durationid: itemData.dealerid,
    //     purchaselimitid: itemData?.purchaselimitid,
    //   });
    // }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Guarantee${
          action === "agreement-edit-3"
            ? `${itemData?.policynumber ? " - " + itemData?.policynumber : ""}`
            : ""
        }`}
        isLoading={isLoading}
      />
      <Layout>
        <SimpleGrid
          columns={ismobile ? 1 : 2}
          // maxWidth={"25rem"}
          columnGap="1rem"
          rowGap="1rem"
          // borderWidth={'2px'}
          // p={'2rem'}
          // borderRadius={'1rem'}
        >
          <InputComp
            label={"Start Date"}
            type="date"
            value={startdate}
            onChange={setStartdate}
            required={true}
          />

          <InputComp
            label={"Vehicle Catergory"}
            type="text"
            value={vehiclecategory}
            onChange={setVehiclecategory}
          />

          <InputComp
            label={"Purchase Duration"}
            type="dropdown"
            items={purchasedurDD}
            onChange={onChangePurchasedurDD}
            placeholder={"Select Duration"}
            required={true}
          />

          <InputComp
            label={"Purchase Claim Limit"}
            type="dropdown"
            items={purClaimLimitDD}
            onChange={onChangeClaimLimitDD}
            placeholder={"Select Limit"}
            required={true}
          />

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Start Date <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              type="date"
              value={utils.dateToDateInput(startdateseconds)}
              onChange={(e) => setStartdateseconds(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Vehicle Catergory</Field.Label>
            <Input
              type="text"
              value={vehiclecategory}
              onChange={(e) => setVehiclecategory(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Purchase Duration <Field.Label color={"red"}>*</Field.Label>{" "}
            </Field.Label>
            <DropDown
              w={"100%"}
              textStyle={fs}
              items={purchasedurDD}
              onChange={onChangePurchasedurDD}
              placeholder={"Select Duration"}
            />
          </Field.Root> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Purchase Claim Limit <Field.Label color={"red"}>*</Field.Label>{" "}
            </Field.Label>
            <DropDown
              w={"100%"}
              textStyle={fs}
              items={purClaimLimitDD}
              onChange={onChangeClaimLimitDD}
              placeholder={"Select Limit"}
            />
          </Field.Root> */}

          {/* </SimpleGrid> */}
          {/* <Flex direction={"column"} gap={4}> */}
          {/* </Flex> */}
        </SimpleGrid>
        <Flex
          flexFlow={"wrap"}
          // orientation={ismobile ? "vertical" : "horizontal"}
          gap={6}
          mt={4}
        >
          <ToggleSwitch label={"DPFS"} value={dpfs} onChange={setDpfs} />
          <ToggleSwitch
            label={"Higher Labour Rate"}
            value={higherlabourrate}
            onChange={setHigherlabourrate}
          />
          <ToggleSwitch
            label={"Wear and Tear"}
            value={weartear}
            onChange={setWeartear}
          />
          <ToggleSwitch
            label={"EGR Valves"}
            value={egrvalves}
            onChange={setEgrvalves}
          />
          <ToggleSwitch
            value={catalyticconverter}
            onChange={setCatalyticconverter}
            label={"Catalytiy Converter"}
          />
        </Flex>
      </Layout>

      <Flex
        alignItems={"center"}
        justify={"space-between"}
        gap={"1rem"}
        wrap={"wrap"}
      >
        <ButtonComp label="Clear" onClick={clearForm} keyname="clear" />
        <Flex flex={1} bg={"red"} />
        <ButtonComp label="Close" onClick={onClose} keyname="close" />
        <ButtonComp label="Previous" onClick={onPrev} keyname="prev" />
        <ButtonComp
          label="Save"
          onClick={onSave}
          keyname="save"
          disabled={isLoading}
        />
      </Flex>
    </Flex>
  );
}

export default Guarantee;
